import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { getUserFormData } from "modules/user/user-selectors";
import UserActions from "modules/user/user-actions";
// import GeneralInfoForm from "modules/general-info/general-info-form";
import InitialDiagnostic from "modules/general-info/initial-diagnostic";

class GeneralInfo extends Component {
  static propTypes = {
    user: PropTypes.object,
    updateUser: PropTypes.func.isRequired
  };

  render() {
    // const { user, updateUser } = this.props;
    return (
      <div className="GeneralInfo">
        <h1>
          <FormattedMessage id="general-info.title" />
        </h1>
        {/*user && (
          <GeneralInfoForm
            initialValues={user}
            onSubmit={values => updateUser(values)}
          />
        )*/}
        <InitialDiagnostic />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: getUserFormData(state)
});

const mapDispatchToProps = {
  updateUser: UserActions.Creators.generalInfoUpdated
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralInfo);



// WEBPACK FOOTER //
// ./src/modules/general-info/general-info.js